<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-10 09:24:31
-->
<template>
  <div>
    <div class="main">
      <!-- 中部小导航 -->
      <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">公告公示</div>
        <div class="mbx">
          <el-page-header @back="goBack"></el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>详情页</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="nav">
          <a
            :class="{ on: item.dictValue == tid }"
            v-for="(item, index) in navlist"
            @click="changetab(item.dictValue, item.remark)"
            :key="index"
            >{{ item.dictName }}</a
          >
        </div>
      </div>
    </div> -->
      <!-- 中部小导航 end-->
      <div class="nav">
        <div class="title">{{ leftNavName }}</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div>
      <div class="content">
        <div class="mbx">
          <el-page-header @back="goBack"></el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>详情页</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="article">
          <div class="titlename">
            <h2>
              {{ info.title }}
            </h2>
            <p>
              <span
                >发布时间：{{ info.lrsj ? info.lrsj.split(" ")[0] : "" }}</span
              >
            </p>
          </div>
          <div class="nr" v-html="info.dynr"></div>
          <a class="download" @click="download" v-if="!!info.scmc"
            ><i class="el-icon-download"></i> 下载附件 - {{ info.scmc }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tid: "",
      navlist: [],
      info: {},
      id: "0",
      leftNavName: ""
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.id = this.$route.query.id;
        // 二级菜单时，获取companySummaryType
        var nav = JSON.parse(localStorage.getItem("nav"));
        this.leftNavName = nav.filter(item => {
          return item.parent.code === "websiteBusiness";
        })[0].parent.name;
        var navlist = nav.filter(item => {
          return item.parent.code === "websiteBusiness";
        })[0].child;
        this.navlist = navlist;
        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    getinfo() {
      this.$get("/website/fbggInfo/" + this.id).then(res => {
        this.info = res.data;
      });
    },
    download() {
      var url =
        this.$baseURL +
        "/office/file/downloadFile?menuCode=wesiteNotice&fileName=" +
        this.info.scmc;
      window.open(url);
    },
    goBack() {
      this.$router.go(-1);
    },
    changetab(index, remark) {
      // if (index === "999") {
      //   window.open(remark);
      // } else {
      //   this.$router.push({
      //     path: "/notice/notice",
      //     query: { tid: index, pageno: 1 }
      //   });
      // }
      if (index === "999") {
        window.open(remark);
      } else {
        this.$router.push({
          path: "/websitebusiness/websitebusiness",
          query: { tid: index, tabid: 0 }
        });
      }
    }
  }
};
</script>
<style scoped>
.content {
  /* width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  position: relative;
  line-height: 42px; */
  position: relative;
  padding: 0 20px 20px 20px;
}
.download {
  /* position: absolute;
  right: 20px;
  top: 88px; */
  display: inline-block;
  background: #ddd;
  padding: 8px 10px;
  margin: 0 0 20px 20px;
  border-radius: 3px;
  line-height: 20px;
}
.download:hover {
  background: rgb(138, 159, 197);
  color: #fff;
}
.article {
  background: #fff;
}
.titlename {
  padding: 30px 0;
  border-bottom: 1px dashed #ccc;
}
.nr {
  padding: 20px 60px;
}
.nr /deep/img {
  max-width: 100%;
}
.titlename h2 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.titlename p {
  text-align: center;
}
.titlename p span {
  padding: 10px 0;
}
/* 中部小导航 */
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.mbx {
  padding: 10px 0;
}
.el-page-header,
.el-breadcrumb {
  display: inline-block;
}
.el-page-header:hover /deep/ .el-page-header__title {
  color: #409eff;
}
.islinkitem /deep/.el-breadcrumb__inner {
  font-weight: bold;
  cursor: pointer;
  color: #303133;
}
.islinkitem /deep/.el-breadcrumb__inner:hover {
  color: #409eff;
}
</style>
